import React from 'react';
import { CtaButton } from './CtaButton';
export function Price() {
  return <div className="text-center" data-id="element-156" data-mp="2co3ylkbsl4kr">
      <div className="flex items-end justify-center gap-8" data-id="element-157" data-mp="2cp5i8d6vize3">
        <div data-id="element-158" data-mp="2hn72v2jy76ro">
          <p className="text-[12px] font-semibold uppercase tracking-[0.18em] text-ink-mute" data-id="element-159" data-mp="2hmnjriikacc2">Total value</p>
          <p className="mt-1 font-display text-[34px] leading-none text-ink-mute line-through decoration-terra decoration-2" data-id="element-160" data-mp="2me5kq6kl4cx1">$97</p>
        </div>
        <div data-id="element-161" data-mp="2qf91qwedcezu">
          <p className="text-[12px] font-semibold uppercase tracking-[0.18em] text-terra-deep" data-id="element-162" data-mp="2qhv5eky52acs">Today</p>
          <p className="mt-1 font-display text-[76px] leading-[0.85] text-ink" data-id="element-163" data-mp="2vgeqyk8tlk4m">$37</p>
        </div>
      </div>

      <CtaButton to="checkout" block className="mt-7" data-id="element-164" data-mp="35chunujblqto">
        Get Instant Access
      </CtaButton>

      <p className="mt-4 text-[13px] font-medium text-ink sm:text-[14px]" data-id="element-165" data-mp="15zx8p5xfxlzn">One-Time Payment • No Subscription • Instant Digital Access</p>
      <p className="mt-1 text-[14px] font-semibold text-sage-deep" data-id="element-166" data-mp="1azjmphl3f69i">Free Lifetime Updates Included</p>
    </div>;
}